import { render, staticRenderFns } from "./DHPowerBall.vue?vue&type=template&id=463be2da&scoped=true"
import script from "./DHPowerBall.vue?vue&type=script&lang=js"
export * from "./DHPowerBall.vue?vue&type=script&lang=js"
import style0 from "./DHPowerBall.vue?vue&type=style&index=0&id=463be2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463be2da",
  null
  
)

export default component.exports